const isAppHealth = process.env.VUE_APP_HEALTH === 'true'
export const dataTypes = isAppHealth ? ['steps', 'distance', 'calories', 'weight', 'height', 'activity'] : ['steps', 'distance', 'calories']
